/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query'
import type {
    MutationFunction,
    QueryClient,
    UseMutationOptions,
    UseMutationResult,
} from '@tanstack/react-query'

import type {
    HTTPValidationErrorDTO,
    PostRequestJobsPublishByJobUuidParams,
    PublishShareResponseDTO,
} from '../../model'

import { customInstance } from '../../../customInstance'
import type { ErrorType } from '../../../customInstance'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * This endpoint is used to send share email and/or
get the share url for a job

 * @summary Publish Share
 */
export const postRequestJobsPublishByJobUuid = (
    jobUuid: string,
    params: PostRequestJobsPublishByJobUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<PublishShareResponseDTO>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/publish`,
            method: 'POST',
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestJobsPublishByJobUuidMutationOptions = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestJobsPublishByJobUuid>>,
        TError,
        { jobUuid: string; params: PostRequestJobsPublishByJobUuidParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestJobsPublishByJobUuid>>,
    TError,
    { jobUuid: string; params: PostRequestJobsPublishByJobUuidParams },
    TContext
> => {
    const mutationKey = ['postRequestJobsPublishByJobUuid']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestJobsPublishByJobUuid>>,
        { jobUuid: string; params: PostRequestJobsPublishByJobUuidParams }
    > = (props) => {
        const { jobUuid, params } = props ?? {}

        return postRequestJobsPublishByJobUuid(jobUuid, params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestJobsPublishByJobUuidMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestJobsPublishByJobUuid>>
>

export type PostRequestJobsPublishByJobUuidMutationError =
    ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Publish Share
 */
export const usePostRequestJobsPublishByJobUuid = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestJobsPublishByJobUuid>>,
            TError,
            { jobUuid: string; params: PostRequestJobsPublishByJobUuidParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestJobsPublishByJobUuid>>,
    TError,
    { jobUuid: string; params: PostRequestJobsPublishByJobUuidParams },
    TContext
> => {
    const mutationOptions =
        getPostRequestJobsPublishByJobUuidMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
